<script setup lang="ts">
/**
 * IGNITE-104: shown when a tokenised affiliate URL does not resolve - unknown
 * token, promotion finished, or the product is no longer flagged as affiliate.
 *
 * Deliberately says nothing about why. Distinguishing "wrong token" from
 * "expired promotion" would leak whether a token exists, which is what the
 * tokenised URL is there to prevent.
 */
</script>

<template>
  <section class="product-not-found">
    <h1>Product not found</h1>
    <p>
      This offer is no longer available, or the link you followed is not valid.
    </p>
    <NuxtLink to="/" class="not-found-cta">Browse our plans</NuxtLink>
  </section>
</template>

<style scoped lang="scss">
.product-not-found {
  max-width: 640px;
  margin: 0 auto;
  padding: 64px 16px 96px;
  text-align: center;

  h1 {
    font-family: "Montserrat", sans-serif;
    font-size: 32px;
    line-height: 40px;
    font-weight: 700;
    color: rgb(var(--primary));
    margin: 0 0 16px;
  }

  p {
    font-family: "Montserrat", sans-serif;
    font-size: 16px;
    line-height: 24px;
    color: #333333;
    margin: 0 0 32px;
  }
}

.not-found-cta {
  display: inline-block;
  padding: 12px 24px;
  border-radius: 9999px;
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  text-decoration: none;
  background-color: rgb(var(--primary));
  color: #ffffff;
}
</style>
